import React from "react";
import { PRIMARY_COLOR, TERTIARY_COLOR } from "../constants/theme";
import { ReactComponent as ChairIcon } from "./../assets/clinic.svg";

const Clinic = ({ clinic, selectedClinicBranch, setSelectedClinicBranch }) => {
  const handleSelection = () => {
    if (selectedClinicBranch && selectedClinicBranch.title === clinic.title) {
      setSelectedClinicBranch(undefined);
    } else {
      setSelectedClinicBranch(clinic);
    }
  };

  return (
    <div className="col p-0">
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{
          border: `1px solid ${
            selectedClinicBranch?.title === clinic.title
              ? PRIMARY_COLOR
              : TERTIARY_COLOR
          }`,
          width: "100%",
          padding: "15px 10px",
          borderRadius: "16px",
          backgroundColor:
            selectedClinicBranch?.title === clinic.title
              ? TERTIARY_COLOR
              : "unset",
          gap: "15px",
        }}
        onClick={() => handleSelection()}
      >
        <div
          className=""
          style={{
            width: "46px",
          }}
        >
          <ChairIcon
            fill={
              selectedClinicBranch?.title === clinic.title
                ? PRIMARY_COLOR
                : TERTIARY_COLOR
            }
          />
        </div>

        <div
          className="text-center"
          style={{
            fontSize: "16px",
            color: "rgb(203, 108, 230)",
            fontWeight:
              selectedClinicBranch?.title === clinic.title ? "600" : "400",
            lineHeight: "1.35",
            minHeight: "100px",
          }}
        >
          {clinic?.title}
          <p className="mt-1" style={{ color: "black", fontSize: "12px" }}>
            {clinic.address}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Clinic;
